const BreedsTypeMap = {
    'a_c_horse_americanpaint_greyovero': 'American Paint',
    'a_c_horse_americanpaint_overo': 'American Paint',
    'a_c_horse_americanpaint_splashedwhite': 'American Paint',
    'a_c_horse_americanpaint_tobiano': 'American Paint',
    'a_c_horse_americanstandardbred_black': 'American Standardbred',
    'a_c_horse_americanstandardbred_buckskin': 'American Standardbred',
    'a_c_horse_americanstandardbred_lightbuckskin': 'American Standardbred',
    'a_c_horse_americanstandardbred_palominodapple': 'American Standardbred',
    'a_c_horse_americanstandardbred_silvertailbuckskin': 'American Standardbred',
    'a_c_horse_andalusian_darkbay': 'Andalusian',
    'a_c_horse_andalusian_perlino': 'Andalusian',
    'a_c_horse_andalusian_rosegray': 'Andalusian',
    'a_c_horse_appaloosa_blacksnowflake': 'Appaloosa',
    'a_c_horse_appaloosa_blanket': 'Appaloosa',
    'a_c_horse_appaloosa_brownleopard': 'Appaloosa',
    'a_c_horse_appaloosa_fewspotted_pc': 'Appaloosa',
    'a_c_horse_appaloosa_leopard': 'Appaloosa',
    'a_c_horse_appaloosa_leopardblanket': 'Appaloosa',
    'a_c_horse_arabian_black': 'Arabian',
    'a_c_horse_arabian_grey': 'Arabian',
    'a_c_horse_arabian_redchestnut': 'Arabian',
    'a_c_horse_arabian_redchestnut_pc': 'Arabian',
    'a_c_horse_arabian_rosegreybay': 'Arabian',
    'a_c_horse_arabian_warpedbrindle_pc': 'Arabian',
    'a_c_horse_arabian_white': 'Arabian',
    'a_c_horse_ardennes_bayroan': 'Ardennes',
    'a_c_horse_ardennes_irongreyroan': 'Ardennes',
    'a_c_horse_ardennes_strawberryroan': 'Ardennes',
    'a_c_horse_belgian_blondchestnut': 'Belgian Draft',
    'a_c_horse_belgian_mealychestnut': 'Belgian Draft',
    'a_c_horse_breton_grullodun': 'Breton',
    'a_c_horse_breton_mealydapplebay': 'Breton',
    'a_c_horse_breton_redroan': 'Breton',
    'a_c_horse_breton_sealbrown': 'Breton',
    'a_c_horse_breton_sorrel': 'Breton',
    'a_c_horse_breton_steelgrey': 'Breton',
    'a_c_horse_criollo_baybrindle': 'Criollo',
    'a_c_horse_criollo_bayframeovero': 'Criollo',
    'a_c_horse_criollo_blueroanovero': 'Criollo',
    'a_c_horse_criollo_dun': 'Criollo',
    'a_c_horse_criollo_marblesabino': 'Criollo',
    'a_c_horse_criollo_sorrelovero': 'Criollo',
    'a_c_horse_dutchwarmblood_chocolateroan': 'Dutch Warmblood',
    'a_c_horse_dutchwarmblood_sealbrown': 'Dutch Warmblood',
    'a_c_horse_dutchwarmblood_sootybuckskin': 'Dutch Warmblood',
    'a_c_horse_gypsycob_palominoblagdon': 'Gypsy Cob',
    'a_c_horse_gypsycob_piebald': 'Gypsy Cob',
    'a_c_horse_gypsycob_skewbald': 'Gypsy Cob',
    'a_c_horse_gypsycob_splashedbay': 'Gypsy Cob',
    'a_c_horse_gypsycob_splashedpiebald': 'Gypsy Cob',
    'a_c_horse_gypsycob_whiteblagdon': 'Gypsy Cob',
    'a_c_horse_hungarianhalfbred_darkdapplegrey': 'Hungarian Halfbred',
    'a_c_horse_hungarianhalfbred_flaxenchestnut': 'Hungarian Halfbred',
    'a_c_horse_hungarianhalfbred_liverchestnut': 'Hungarian Halfbred',
    'a_c_horse_hungarianhalfbred_piebaldtobiano': 'Hungarian Halfbred',
    'a_c_horse_kentuckysaddle_black': 'Kentucky Saddler',
    'a_c_horse_kentuckysaddle_buttermilkbuckskin_pc': 'Kentucky Saddler',
    'a_c_horse_kentuckysaddle_chestnutpinto': 'Kentucky Saddler',
    'a_c_horse_kentuckysaddle_grey': 'Kentucky Saddler',
    'a_c_horse_kentuckysaddle_silverbay': 'Kentucky Saddler',
    'a_c_horse_kladruber_black': 'Kladruber',
    'a_c_horse_kladruber_cremello': 'Kladruber',
    'a_c_horse_kladruber_dapplerosegrey': 'Kladruber',
    'a_c_horse_kladruber_grey': 'Kladruber',
    'a_c_horse_kladruber_silver': 'Kladruber',
    'a_c_horse_kladruber_white': 'Kladruber',
    'a_c_horse_missourifoxtrotter_amberchampagne': 'Missouri Fox Trotter',
    'a_c_horse_missourifoxtrotter_blacktovero': 'Missouri Fox Trotter',
    'a_c_horse_missourifoxtrotter_blueroan': 'Missouri Fox Trotter',
    'a_c_horse_missourifoxtrotter_buckskinbrindle': 'Missouri Fox Trotter',
    'a_c_horse_missourifoxtrotter_dapplegrey': 'Missouri Fox Trotter',
    'a_c_horse_missourifoxtrotter_sablechampagne': 'Missouri Fox Trotter',
    'a_c_horse_missourifoxtrotter_silverdapplepinto': 'Missouri Fox Trotter',
    'a_c_horse_morgan_bay': 'Morgan',
    'a_c_horse_morgan_bayroan': 'Morgan',
    'a_c_horse_morgan_flaxenchestnut': 'Morgan',
    'a_c_horse_morgan_liverchestnut_pc': 'Morgan',
    'a_c_horse_morgan_palomino': 'Morgan',
    'a_c_horse_mustang_blackovero': 'Mustang',
    'a_c_horse_mustang_buckskin': 'Mustang',
    'a_c_horse_mustang_chestnuttovero': 'Mustang',
    'a_c_horse_mustang_goldendun': 'Mustang',
    'a_c_horse_mustang_grullodun': 'Mustang',
    'a_c_horse_mustang_reddunovero': 'Mustang',
    'a_c_horse_mustang_tigerstripedbay': 'Mustang',
    'a_c_horse_mustang_wildbay': 'Mustang',
    'a_c_horse_nokota_blueroan': 'Nokota',
    'a_c_horse_nokota_reversedappleroan': 'Nokota',
    'a_c_horse_nokota_whiteroan': 'Nokota',
    'a_c_horse_norfolkroadster_black': 'Norfolk Roadster',
    'a_c_horse_norfolkroadster_dappledbuckskin': 'Norfolk Roadster',
    'a_c_horse_norfolkroadster_piebaldroan': 'Norfolk Roadster',
    'a_c_horse_norfolkroadster_rosegrey': 'Norfolk Roadster',
    'a_c_horse_norfolkroadster_speckledgrey': 'Norfolk Roadster',
    'a_c_horse_norfolkroadster_spottedtricolor': 'Norfolk Roadster',
    'a_c_horse_shire_darkbay': 'Shire',
    'a_c_horse_shire_lightgrey': 'Shire',
    'a_c_horse_shire_ravenblack': 'Shire',
    'a_c_horse_suffolkpunch_redchestnut': 'Suffolk Punch',
    'a_c_horse_suffolkpunch_sorrel': 'Suffolk Punch',
    'a_c_horse_tennesseewalker_blackrabicano': 'Tennessee Walker',
    'a_c_horse_tennesseewalker_chestnut': 'Tennessee Walker',
    'a_c_horse_tennesseewalker_dapplebay': 'Tennessee Walker',
    'a_c_horse_tennesseewalker_flaxenroan': 'Tennessee Walker',
    'a_c_horse_tennesseewalker_goldpalomino_pc': 'Tennessee Walker',
    'a_c_horse_tennesseewalker_mahoganybay': 'Tennessee Walker',
    'a_c_horse_tennesseewalker_redroan': 'Tennessee Walker',
    'a_c_horse_thoroughbred_blackchestnut': 'Thoroughbred',
    'a_c_horse_thoroughbred_bloodbay': 'Thoroughbred',
    'a_c_horse_thoroughbred_brindle': 'Thoroughbred',
    'a_c_horse_thoroughbred_dapplegrey': 'Thoroughbred',
    'a_c_horse_thoroughbred_reversedappleblack': 'Thoroughbred',
    'a_c_horse_turkoman_black': 'Turkoman',
    'a_c_horse_turkoman_chestnut': 'Turkoman',
    'a_c_horse_turkoman_darkbay': 'Turkoman',
    'a_c_horse_turkoman_gold': 'Turkoman',
    'a_c_horse_turkoman_grey': 'Turkoman',
    'a_c_horse_turkoman_perlino': 'Turkoman',
    'a_c_horse_turkoman_silver': 'Turkoman',
    'a_c_horse_buell_warvets': 'Special',
    'a_c_horse_eagleflies': 'Special',
    'a_c_horse_gang_bill': 'Special',
    'a_c_horse_gang_charles': 'Special',
    'a_c_horse_gang_charles_endlesssummer': 'Special',
    'a_c_horse_gang_dutch': 'Special',
    'a_c_horse_gang_hosea': 'Special',
    'a_c_horse_gang_javier': 'Special',
    'a_c_horse_gang_john': 'Special',
    'a_c_horse_gang_karen': 'Special',
    'a_c_horse_gang_kieran': 'Special',
    'a_c_horse_gang_lenny': 'Special',
    'a_c_horse_gang_micah': 'Special',
    'a_c_horse_gang_sadie': 'Special',
    'a_c_horse_gang_sadie_endlesssummer': 'Special',
    'a_c_horse_gang_sean': 'Special',
    'a_c_horse_gang_trelawney': 'Special',
    'a_c_horse_gang_uncle': 'Special',
    'a_c_horse_gang_uncle_endlesssummer': 'Special',
    'a_c_horse_john_endlesssummer': 'Special',
    'a_c_donkey_01': 'Other',
    'a_c_horse_mp_mangy_backup': 'Other',
    'a_c_horsemule_01': 'Other',
    'a_c_horsemulepainted_01': 'Other',
    'a_c_horse_murfreebrood_mange_01': 'Other',
    'a_c_horse_murfreebrood_mange_02': 'Other',
    'a_c_horse_murfreebrood_mange_03': 'Other'
};
export default BreedsTypeMap;
